import { useEffect, useRef, useState } from 'react'
import renderPrgImage from '../../../source/programImg'
import styles from './LeftTrainingClass.module.css'
import { connect } from 'react-redux'
import { useIndexedDB } from 'react-indexed-db'

function LeftTrainingClass(props) {
    const {
        jsPlumbInstance,
        obj,
        webCamModelOpen,
        audioModelOpen = () => {},
        isAudioTrain,
        changeClasses,
        classesObjectKey,
        setClasses,
        isShowClassDeleteBtn,
        camModels,
        currentModelId,
    } = props
    const [className, setClassName] = useState(obj.className)
    const [classNameError, setClassNameError] = useState('')
    const [isClassEdit, setIsClassEdit] = useState({
        isEdit: false,
        prevClassname: '',
    })

    const { getAll, getByIndex, deleteRecord, getByID, add } =
        useIndexedDB('SavedFaces')

    // const menuContainerRef = useRef(null)
    const menuIconRef = useRef(null)

    // const classes = isAudioTrain ? props.AudioClasses : props.ImageClasses
    const classes = camModels?.find(
        (model) => model?.modelId === currentModelId
    )?.ImageClasses

    // Validation function
    const validateModelName = (name) => {
        const trimmed = name.trim()
        const regex = /^[a-zA-Z0-9_ ]+$/ // only letters, numbers, underscores, spaces
        // if (!trimmed) return 'Model name cannot be empty'
        if (trimmed.length > 15) return 'Model name must be max 15 characters'
        if (!regex.test(trimmed))
            return 'Special characters or newlines are not allowed'

        let currentModelId = props.appModeStorage.trainMachine.currentModelId
        let camModels = props.appModeStorage.trainMachine.camModels
        let currentModel = camModels.find(
            (model) => model.modelId === currentModelId
        )

        const exists = Object.values(currentModel.ImageClasses).some(
            (cls) => cls.className === trimmed
        )
        if (exists) return 'Model name already exists'
        return ''
    }

    //change the redux state for edit the classname
    const handelChangeClassName = (e) => {
        try {
            e.preventDefault()

            const err = validateModelName(className)
            if (err) {
                setClassNameError(err)
                setTimeout(() => setClassNameError(''), 2000)
                return
            }
            let newClasses = { ...classes }
            newClasses[classesObjectKey] = { ...obj, className: className }

            if (isClassEdit.prevClassname !== className) {
                updateIndexDB(newClasses[classesObjectKey]?.id, className)
            }

            setIsClassEdit({ isEdit: false, prevClassname: '' })
            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'

            changeClasses({ data: newClasses, classType })
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    //delete from indexDB
    const deleteFromIndexDB = (id) => {
        deleteRecord(id)
            .then(() => {
                console.log(`Record with ID '${id}' has been deleted.`)
                // getAll().then((records) => {
                //     console.log(records)
                // })
            })
            .catch((error) => {
                console.error('Error deleting record:', error)
            })
    }

    //update the indexDB with new class name
    const updateIndexDB = async (id, newClassName) => {
        try {
            let records = await getAll()
            const record = records.find((item) => item.id === id)
            if (record) {
                const newData = { ...record, className: newClassName }
                await deleteRecord(id)
                await add(newData)
            }

            let records1 = await getAll()
            console.log('HHHHHHHHHH update result', records1)
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    //delete the class
    const handelClassDelete = () => {
        try {
            if (!isShowClassDeleteBtn) {
                return
            }
            if (Object.keys(classes).length <= 1) {
                return
            }

            let newClasses = { ...classes }
            const leftDivId = `train_left-div-${obj.id}`
            jsPlumbInstance?.deleteConnectionsForElement(leftDivId)

            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'
            deleteFromIndexDB(newClasses[classesObjectKey]?.id)
            delete newClasses[classesObjectKey]
            changeClasses({ data: newClasses, classType })
            // props.setToggleNextBtn(true)
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    //remove all the samples
    const handelRemoveSamples = () => {
        try {
            let selectedClassDetails = obj
            selectedClassDetails.capturedImages = []
            setClasses({
                key: classesObjectKey,
                data: selectedClassDetails,
                classType: 'ImageClasses',
            })
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    //remove only single image
    const removeSingleSample = (index) => {
        try {
            let selectedClassDetails = obj
            let imgArr = selectedClassDetails.capturedImages
            imgArr.splice(index, 1)
            selectedClassDetails.capturedImages = imgArr
            setClasses({
                key: classesObjectKey,
                data: selectedClassDetails,
                classType: 'ImageClasses',
            })
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    //--------------------------------------------------------------------------------------
    const containerRef = useRef(null)
    // const [visibleCount, setVisibleCount] = useState(
    //     props.ImageClasses?.[classesObjectKey]?.capturedImages?.length
    // )

    // useEffect(() => {
    //     const calculateVisibleImages = () => {
    //         if (containerRef.current) {
    //             const containerWidth = containerRef.current.offsetWidth
    //             const imageWidth = 70 // fixed image width
    //             const gap = 15
    //             const totalPerImage = imageWidth + gap
    //             const count = Math.floor((containerWidth + gap) / totalPerImage)
    //             setVisibleCount(count)
    //         }
    //     }

    //     // Initial calculation
    //     calculateVisibleImages()

    //     // Recalculate on window resize
    //     window.addEventListener('resize', calculateVisibleImages)
    //     return () =>
    //         window.removeEventListener('resize', calculateVisibleImages)
    // }, [])

    // const imagesToShow = props.ImageClasses?.[classesObjectKey]?.capturedImages //?.slice(0, visibleCount)
    const imagesToShow = classes?.[classesObjectKey]?.capturedImages
    // const remainingCount =
    //     props?.ImageClasses[classesObjectKey]?.capturedImages?.length -
    //     visibleCount
    //--------------------------------------------------------------------------------------

    return (
        <div>
            <div className={styles.trainClassHeader}>
                <div className={styles.trainClassNameDiv}>
                    {isClassEdit.isEdit ? (
                        <form onSubmit={handelChangeClassName}>
                            <input
                                className={styles.classnameInput}
                                value={className}
                                placeholder="Enter The Class Name"
                                onChange={(e) => setClassName(e.target.value)}
                                onBlur={handelChangeClassName}
                            />
                            {classNameError && (
                                <p className={styles.classNameInputError}>
                                    {classNameError}
                                </p>
                            )}
                        </form>
                    ) : (
                        <>
                            <p
                                style={{
                                    marginBottom: '0',
                                    marginRight: '8px',
                                }}
                            >
                                {obj.className}{' '}
                            </p>
                            <div style={{ position: 'relative' }}>
                                <img
                                    id={styles.editPencilImg}
                                    width={'28px'}
                                    style={{ cursor: 'pointer' }}
                                    src={renderPrgImage('editPencil')}
                                    alt="edit class name"
                                    onClick={() =>
                                        setIsClassEdit({
                                            isEdit: true,
                                            prevClassname: className,
                                        })
                                    }
                                />
                                <div
                                    className={`${styles.tooltipDiv} ${styles.pencilToolTip}`}
                                >
                                    Edit Class Name
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className={styles.menuParentDiv}>
                    {imagesToShow.length > 0 && (
                        <div className={styles.imageCountDiv}>
                            <p style={{ marginBottom: '0' }}>
                                {imagesToShow.length} Image samples
                            </p>
                        </div>
                    )}
                    <div style={{ position: 'relative' }}>
                        <img
                            ref={menuIconRef}
                            id={styles.uploadImg}
                            style={{ cursor: 'pointer' }}
                            src={renderPrgImage('photoUpload')}
                            alt="Upload"
                            onClick={() =>
                                webCamModelOpen({
                                    value: true,
                                    imageUpload: true,
                                    classesObjectKey: classesObjectKey,
                                })
                            }
                        />
                        <div
                            className={`${styles.tooltipDiv} ${styles.uploadToolTip}`}
                        >
                            Upload
                        </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <img
                            ref={menuIconRef}
                            id={styles.webCamImg}
                            style={{ cursor: 'pointer' }}
                            src={renderPrgImage('webCam')}
                            alt="Webcam"
                            onClick={() =>
                                webCamModelOpen({
                                    value: true,
                                    imageUpload: false,
                                    classesObjectKey: classesObjectKey,
                                })
                            }
                        />
                        <div
                            className={`${styles.tooltipDiv} ${styles.webCamToolTip}`}
                        >
                            Webcam
                        </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <img
                            ref={menuIconRef}
                            id={styles.deleteClassImg}
                            style={
                                isShowClassDeleteBtn
                                    ? { cursor: 'pointer' }
                                    : { cursor: 'default' }
                            }
                            src={
                                isShowClassDeleteBtn
                                    ? renderPrgImage('deleteEnable')
                                    : renderPrgImage('deletDisable')
                            }
                            alt="Delete class"
                            onClick={() => handelClassDelete()}
                        />
                        <div
                            className={`${styles.tooltipDiv} ${styles.deleteClassToolTip}`}
                        >
                            Delete class
                        </div>
                    </div>
                    {/* <div
                        ref={menuContainerRef}
                        className={
                            isShowMenu
                                ? `${styles.menuDiv} ${styles.active}`
                                : `${styles.menuDiv} `
                        }
                    >
                        <p onClick={handelClassDelete}>Delete Class</p>
                        <p onClick={handelRemoveSamples}>Remove All Samples</p>
                    </div> */}
                </div>
            </div>
            {/* <p>Add Samples:</p> */}
            <div
                // style={{ border: '1px solid red' }}
                className={styles.trainClassBodyDiv}
            >
                <div className={styles.samplesDivParent}>
                    <div className={styles.samplesDiv} ref={containerRef}>
                        {imagesToShow.map((img, index) => (
                            <div key={index} className={styles.sampleImgDiv}>
                                <img
                                    src={img}
                                    width="70"
                                    height="70"
                                    alt={`Captured ${index}`}
                                    className={styles.sampleImage}
                                    style={{ borderRadius: '5px' }}
                                />
                                <img
                                    src={renderPrgImage('eachImgCross')}
                                    className={styles.imgDelete}
                                    id={styles.imgDelete}
                                    alt="delete each image"
                                    onClick={() => removeSingleSample(index)}
                                />
                                <div
                                    className={`${styles.tooltipDiv} ${styles.imgDeleteToolTip}`}
                                >
                                    Delete image
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* {imagesToShow.length > 0 && (
                        <div className={styles.moreImages}>
                            <div style={{ position: 'relative' }}>
                                <img
                                    width="30"
                                    height="30"
                                    ref={menuIconRef}
                                    id={styles.deleteAllImg}
                                    style={{
                                        cursor: 'pointer',
                                        marginLeft: '10px',
                                    }}
                                    src={renderPrgImage('crossEnable')}
                                    alt="Delete all samples"
                                    onClick={() => handelRemoveSamples()}
                                />
                                <div
                                    className={`${styles.tooltipDiv} ${styles.deleteAllToolTip}`}
                                >
                                    Delete all samples
                                </div>
                            </div>
                        </div>
                    )} */}
                    {/* {remainingCount > 0 && (
                        <div className={styles.moreImages}>
                            +{remainingCount}
                        </div>
                    )} */}
                </div>

                <div style={{ position: 'relative' }}>
                    <img
                        width="35"
                        height="35"
                        ref={menuIconRef}
                        id={styles.deleteAllImg}
                        style={
                            imagesToShow.length > 0
                                ? { cursor: 'pointer' }
                                : { cursor: 'default' }
                        }
                        src={
                            imagesToShow.length > 0
                                ? renderPrgImage('crossEnable')
                                : renderPrgImage('crossDisable')
                        }
                        alt="Delete all samples"
                        onClick={() => handelRemoveSamples()}
                    />
                    <div
                        className={`${styles.tooltipDiv} ${styles.deleteAllToolTip}`}
                    >
                        Delete all samples
                    </div>
                </div>
                {/* {!isAudioTrain && (
                    <div
                        onClick={() =>
                            webCamModelOpen({
                                value: true,
                                imageUpload: false,
                                classesObjectKey: classesObjectKey,
                            })
                        }
                        className={styles.webCamDiv}
                    >
                        <img src={renderPrgImage('webcam')} alt="webCam" />
                        <p>Webcam</p>
                    </div>
                )}
                {!isAudioTrain && (
                    <div
                        onClick={() =>
                            webCamModelOpen({
                                value: true,
                                imageUpload: true,
                                classesObjectKey: classesObjectKey,
                            })
                        }
                        className={styles.webCamDiv}
                    >
                        <img
                            src={renderPrgImage('teachableMachineUploadIcon')}
                            alt="upload"
                        />
                        <p>Upload</p>
                    </div>
                )} */}

                {/* {isAudioTrain && (
                    <div
                        onClick={() =>
                            audioModelOpen({
                                value: true,
                                audioUpload: false,
                                className: obj.className,
                            })
                        }
                        className={styles.webCamDiv}
                    >
                        <img
                            src={renderPrgImage('teachableMachineMic')}
                            alt="upload"
                        />
                        <p>Mic</p>
                    </div>
                )} */}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        appModeStorage: state.appModeStorage,
        // ImageClasses: state.appModeStorage.trainMachine.camModels.ImageClasses,
        // AudioClasses: state.appModeStorage.trainMachine.AudioClasses,
        camModels: state.appModeStorage.trainMachine.camModels,
        currentModelId: state.appModeStorage.trainMachine.currentModelId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //AI_TRAIN_LIST
        setNewClasses: (data) => {
            dispatch({ type: 'ADD_CLASSES', payload: data })
        },
        changeClasses: (data) => {
            dispatch({ type: 'CHANGE_CLASSES', payload: data })
        },
        setClasses: (data) => {
            dispatch({ type: 'ADD_CLASSES', payload: data })
        },
        // setToggleNextBtn: (data) => {
        //     dispatch({ type: 'TOGGLE_NEXT_BTN', payload: data })
        // },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftTrainingClass)
